import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

// The customer's Aadhaar or other photo ID, from their trip page. The trip link is the credential.
const base = (token) => `${API_BASE_URL}/api/tracking/${encodeURIComponent(token)}/id-cards`;

export const listCustomerIdCards = async (token) => (await axios.get(base(token))).data;

export const uploadCustomerIdCard = async (token, file) => {
  const form = new FormData();
  form.append("file", file);
  return (await axios.post(base(token), form, { headers: { "Content-Type": "multipart/form-data" } })).data;
};

export const removeCustomerIdCard = async (token, id) => (await axios.delete(`${base(token)}/${id}`)).data;

export const customerIdCardFileUrl = (token, id) => `${base(token)}/${id}/file`;
